module.exports = __webpack_public_path__ + "img/hr-red-asterisk-08.9d4761b4.png";